"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_core_ui_1 = require("@snapchat/web-core-ui");
const web_frame_1 = require("@snapchat/web-frame");
const web_i18n_1 = require("@snapchat/web-i18n");
const web_sds_c_1 = require("@snapchat/web-sds-c");
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const messageLoader_1 = require("../../../i18n/messageLoader");
const constants_1 = require("./constants");
const NoContent_module_css_1 = __importDefault(require("./NoContent.module.css"));
function getMessageForReason(reason) {
    switch (reason) {
        case constants_1.Reason.CONTENT_NOT_AVAILABLE_IN_LOCATION:
            return ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "9hiucJ", description: "Text displayed on an error page when a user tries to see content that is not available in their location.", defaultMessage: "This content is not available in your location" }));
        case constants_1.Reason.CONTENT_NOT_FOUND:
            return ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "AtLF/u", description: "Text displayed on an error page when a user tries to see content that wasn't found.", defaultMessage: "This content was not found" }));
        case constants_1.Reason.CONTENT_NOT_AVAILABLE:
            return ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "JbCR5V", description: "Text displayed on an error page when a user tries to see content that is not available to them.", defaultMessage: "This content is not available" }));
        case constants_1.Reason.ERROR_OCCURED:
            return ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "Gg91U9", description: "Text displayed when an error occured while rendering page", defaultMessage: "Something went wrong. Please try again" }));
    }
}
function displayContentNotAvailableHeading() {
    return ((0, jsx_runtime_1.jsx)(web_sds_c_1.Heading, { size: "H1", children: (0, jsx_runtime_1.jsx)("span", { className: NoContent_module_css_1.default.title, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "6yvoZD", description: "Text displayed as a big heading on an error page when a user tries to see content that is not available to them.", defaultMessage: "Sorry," }) }) }));
}
function displaySubHeading(reason) {
    return ((0, jsx_runtime_1.jsx)(web_sds_c_1.Heading, { size: "H5", children: (0, jsx_runtime_1.jsx)("span", { className: NoContent_module_css_1.default.subtitle, children: getMessageForReason(reason) }) }));
}
function displayContent(reason) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: NoContent_module_css_1.default.columnItem, children: [displayContentNotAvailableHeading(), displaySubHeading(reason)] }));
}
/**
 * A generic page to display when the requested content isn't available for some reason.
 */
function NoContent({ locale, reason, changeLocale, pageType, hideFooter, }) {
    const preferredLocale = (0, web_i18n_1.getLocale)(locale);
    const [messages, setMessages] = (0, react_1.useState)({});
    const isDesktop = (0, web_frame_1.useDesktopMediaQuery)();
    const NO_CONTENT_DESKTOP_TEST = "SnapchatDotCom_NoContentDesktop";
    const NO_CONTENT_MOBILE_TEST = "SnapchatDotCom_NoContentMobile";
    (0, react_1.useEffect)(() => {
        void (0, messageLoader_1.loadMessages)(preferredLocale).then((messages) => {
            setMessages(messages);
        });
    }, [preferredLocale]);
    return ((0, jsx_runtime_1.jsx)(react_intl_1.IntlProvider, { locale: preferredLocale, defaultLocale: web_i18n_1.DEFAULT_LOCALE, messages: messages, children: (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)(web_core_ui_1.CenteredContainer, { children: isDesktop ? ((0, jsx_runtime_1.jsx)("div", { className: NoContent_module_css_1.default.desktopContainer, "data-testid": NO_CONTENT_DESKTOP_TEST, children: displayContent(reason) })) : ((0, jsx_runtime_1.jsx)("div", { className: NoContent_module_css_1.default.mobileContainer, "data-testid": NO_CONTENT_MOBILE_TEST, children: displayContent(reason) })) }), hideFooter ? null : ((0, jsx_runtime_1.jsx)(web_frame_1.CTAFooter, { locale: preferredLocale, downloadUrl: (0, web_frame_1.generateAttributedDownloadUrl)(pageType), localeChange: changeLocale, pageType: pageType, isMobile: !isDesktop }))] }) }));
}
exports.NoContent = NoContent;
//# sourceMappingURL=NoContent.js.map